/* eslint-disable @scandipwa/scandipwa-guidelines/jsx-no-conditional */
/* eslint-disable react/no-unknown-property */
/**
 * @category  Puma
 * @author    Deniss Dubinins <denissd@scandiweb.com | info@scandiweb.com>
 * @copyright Copyright (c) 2022 Scandiweb, Inc (https://scandiweb.com)
 * @license   http://opensource.org/licenses/OSL-3.0 The Open Software License 3.0 (OSL-3.0)
 */

import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import './SelectedFilters.style';

/** @namespace Scandipwa/Component/SelectedFilters/Component */
export class SelectedFiltersComponent extends PureComponent {
    static propTypes = {
        selectedFilters: PropTypes.objectOf(PropTypes.shape).isRequired,
        availableFilters: PropTypes.objectOf(PropTypes.shape).isRequired,
        onResetClick: PropTypes.func.isRequired
    };

    renderSelectedFilters = this.renderSelectedFilters.bind(this);

    renderSelectedFilter = this.renderSelectedFilter.bind(this);

    renderSelectedPriceFilter = this.renderSelectedPriceFilter.bind(this);

    renderSelectedFilters() {
        const { selectedFilters: { customFilters } } = this.props;

        return (
            <>
                { this.renderSelectedPriceFilter() }
                { Object.keys(customFilters).map(this.renderSelectedFilter) }
            </>
        );
    }

    renderSelectedPriceFilter() {
        const {
            selectedFilters: {
                priceRange: { min, max } = {}
            },
            onResetClick
        } = this.props;

        if (!min && !max) {
            return null;
        }

        return (
            <div
              role="button"
              tabIndex={ 0 }
              block="CategoryPage"
              elem="SelectedFilter"
              // eslint-disable-next-line react/jsx-no-bind
              onKeyUp={ () => onResetClick('price') }
              // eslint-disable-next-line react/jsx-no-bind
              onClick={ () => onResetClick('price') }
            >
                { `${ __('Price') }: ${ min }-${ max }` }
            </div>
        );
    }

    renderSelectedFilter(filterCode) {
        const {
            selectedFilters: { customFilters: selectedFilters },
            availableFilters,
            onResetClick
        } = this.props;
        const attribute = availableFilters[filterCode] || {};
        const selectedOptionIds = selectedFilters[filterCode];
        const { attribute_label, attribute_options, is_boolean } = attribute;

        // Adding check for possibility that no attribute options are added
        if (!attribute_options) {
            return null;
        }

        return selectedOptionIds.map((optionId) => {
            const { label: optionLabel } = attribute_options[optionId] || [];

            return (
                <div
                  role="button"
                  tabIndex={ 0 }
                  block="CategoryPage"
                  elem="SelectedFilter"
                  // eslint-disable-next-line react/jsx-no-bind
                  onKeyUp={ () => onResetClick(filterCode, optionId) }
                  // eslint-disable-next-line react/jsx-no-bind
                  onClick={ () => onResetClick(filterCode, optionId) }
                >
                    { is_boolean
                        ? `${ attribute_label || filterCode }`
                        : `${ attribute_label || filterCode }: ${ optionLabel || optionId }` }
                </div>
            );
        });
    }

    render() {
        const {
            selectedFilters: {
                customFilters = {},
                priceRange: {
                    min,
                    max
                } = {}
            } = {},
            availableFilters,
            onResetClick
        } = this.props;

        if (!Object.keys(availableFilters).length
            || (!Object.keys(customFilters).length && !(min || max))
        ) {
            return null;
        }

        return (
            <div block="CategoryPage" elem="SelectedFilters">
                { this.renderSelectedFilters() }
                <div
                  role="button"
                  tabIndex={ 0 }
                  block="CategoryPage"
                  elem="SelectedFilter"
                  mods={ { clearAll: true } }
                  onKeyDown={ onResetClick }
                  onClick={ onResetClick }
                >
                    { __('Clear all') }
                </div>
            </div>
        );
    }
}

export default SelectedFiltersComponent;
